angular.module('unergie.main')
.controller('logCallModalCtrl', ($scope, $timeout, $filter, $window, $uibModalInstance, DataAccess, ApiUser, Contacts, AdminComments,
    idAccount, callId, ReferencesService, BoFeaturesService, AlertManager, MetaWatcher, ErrorCatcher) => {
    $scope.callId = callId

    $scope.account = undefined
    $scope.logObjects = []
    $scope.selectedObject = undefined
    $scope.callEnding = undefined
    $scope.comments = undefined
    $scope.escalationMode = false

    $scope.links = [
        { href: 'https://b2s-et-plum.slack.com/messages/C62GY61A5', label: '#general' },
        { href: 'https://b2s-et-plum.slack.com/messages/C635JQZL4', label: '#activation' },
        { href: 'https://b2s-et-plum.slack.com/messages/C63U2D6KY', label: '#bug-plüm' },
        { href: 'https://b2s-et-plum.slack.com/messages/C6371F6A1', label: '#service-client' },
        { href: 'https://b2s-et-plum.slack.com/messages/C63U26VBQ', label: '#vente' },
    ]

    $scope.showEscalation = BoFeaturesService.getModuleFeatures('accountinfo').showEscalation

    if (!$scope.showEscalation) {
        $scope.callEnding = 'PROBLEM_SOLVED'
    }

    DataAccess.accountAndContracts({ id_account: idAccount }).$promise.then((accountResult) => {
        if (accountResult != null && accountResult.toJSON) {
            const account = accountResult.toJSON()
            $scope.account = account
            $scope.logObjects.push({ object: account.customer_id, label: 'Compte client', tag: 'SERVICE CLIENT', elemClass: 'account-item', picto: 'fa-user-circle-o', title: 'SERVICE CLIENT' })
            _.each(account.contractsElec, (contractElec) => {
                const { prm } = contractElec
                const address = `${prm.addr_num_street} ${prm.addr_post_code} ${prm.addr_city_lbl}`
                let tag = 'SERVICE CLIENT'
                let elemClass = 'contract-item'
                const picto = 'fa-bolt'
                if ([-1, 0, 1, 9, 10, 80, 81, 82, 83].includes(contractElec.status)) {
                    tag = 'ACTIVATION'
                    elemClass = 'activation-item'
                }
                $scope.logObjects.push({ object: contractElec.id, label: `Contrat ${contractElec.id} - ${address}`, tag, elemClass, picto, title: `${tag} : ${address}` })
            })
            return DataAccess.contractDrafts({ id_account: idAccount }).$promise.then((drafts) => {
                if (drafts != null && drafts.length) {
                    _.each(drafts, (draft) => {
                        let address
                        const tag = 'VENTE'
                        let title = tag
                        if (draft.addr_num_street) {
                            address = `${draft.addr_num_street} ${draft.addr_post_code} ${draft.addr_city_lbl}`
                            title += ` : ${address}`
                        }
                        $scope.logObjects.push({ object: draft.id, label: `Draft ${draft.id}`, tag, elemClass: 'draft-item', picto: 'fa-pencil', title })
                    })
                }
            })
        }
    })

    Contacts.getPhoneContact({ id: callId }).$promise.then((contactResult) => {
        if (contactResult && contactResult.toJSON) {
            $scope.contact = contactResult.toJSON()
        }
    })


    $scope.isSelected = (logObject) => ($scope.selectedObject && $scope.selectedObject.object) === logObject.object

    $scope.select = (logObject) => {
        $scope.selectedObject = logObject
    }

    $scope.canSave = () => ($scope.callEnding !== undefined) && ($scope.selectedObject !== undefined) && $scope.comments

    $scope.sendSatisfaction = function () {
        $scope.sendingSatisfaction = true
        AlertManager.error('Désolé le mail n\'existe pas, j\'ai rien fait !')
        // TODO MAiL
        $scope.sendingSatisfaction = false
    }


    $scope.sendTuto = function () {
        $scope.sendingTuto = true
        AlertManager.error('Désolé le mail n\'existe pas, j\'ai rien fait !')
        // TODO MAiL
        $scope.sendingTuto = false
    }

    const generateSlackText = function () {
        let text = `*Client* : ${$scope.account.civ} ${$scope.account.givenname} ${$scope.account.sn}`
        text += ` - ${$filter('accountStatus')($scope.account.status)}\n`
        text += `Appel du *${moment($scope.contact.updatedAt).format('DD/MM/YYYY[* à *]HH:mm')}*\n`
        text += `*Object* : ${$scope.selectedObject.label}\n`
        text += `@channel : ${$scope.comments}\n`
        text += `${$window.location}\n`
        text += '*Escalade indisponible*'
        return text
    }

    $scope.save = function () {
        $scope.saving = true
        const payload = {
            functionalId: $scope.selectedObject.object,
            callEnding: $scope.callEnding,
            tag: $scope.selectedObject.tag,
            comment: $scope.comments || `<b>AUTOMATIQUE</b> : ${$scope.comments || (`Appel répondu concernant <b>${$scope.selectedObject.object}</b>, pas de commentaire`)}`,
        }
        return ApiUser.logCallComment({ id: callId }, payload).$promise
        .then(() => {
            AlertManager.success('Contact téléphonique mis à jour')
            MetaWatcher.notif('CONTACTS_CHANGED')
            if ($scope.showEscalation && ($scope.callEnding === 'ESCALATION_UNAVAILABLE')) {
                $scope.slackText = generateSlackText()
                $scope.escalationMode = true
            } else {
                $scope.ok()
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.saving = false
        })
    }

    let t
    $scope.startAnimation = function () {
        if ((t != null ? t.$$state.status : undefined) === 0) {
            $scope.clicked = false
            $timeout.cancel(t)
            $timeout(() => {
                $scope.clicked = true
            })
        } else {
            $scope.clicked = true
        }
        t = $timeout(() => {
            $scope.clicked = false
        }, 2000)
    }

    // RETURN OK
    $scope.ok = () => $uibModalInstance.close()

    $scope.close = () => $uibModalInstance.dismiss()
})
